import React from 'react';
import { ActivityIndicator, View, StyleSheet, Text, Platform } from 'react-native';
import Colors from 'src/core/utils/Colors';
import Dimens from 'src/core/utils/Dimens';

interface LoaderProps {
	bgColor?: string;
	message?: string;
	small?: boolean;
}

export default function Loader({ bgColor, message, small }: LoaderProps) {
	// `small` = inline (flex:0) spinner for forms/buttons.
	const spinnerSize = small || Platform.OS === 'ios' ? 'small' : 'large';

	return (
		<View
			style={[
				styles.indicatorWrapper,
				bgColor ? { backgroundColor: bgColor } : { backgroundColor: Colors.white },
				small ? styles.small : null,
			]}
		>
			<ActivityIndicator color={Colors.darkGrey} size={spinnerSize} />
			{message ? <Text style={styles.loadingText}>{message}</Text> : null}
		</View>
	);
}

const styles = StyleSheet.create({
	indicatorWrapper: {
		flex: 1,
		justifyContent: 'center',
	},
	small: {
		flex: 0,
	},
	loadingText: {
		textAlign: 'center',
		marginTop: Dimens.margin12,
	},
});
